var map = {
	"./1.png": "5dfb",
	"./2.png": "375a",
	"./3.png": "b0e0",
	"./4.png": "6028",
	"./5.png": "49a9",
	"./6.png": "e84c",
	"./7.png": "6be0",
	"./8.png": "218b",
	"./9.png": "91a6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7380";